export default {
  getProduct: 'get-all-product',
  getUserData: 'get-user-data',
  getRoles: 'get-all-roles'
}